export const REQUEST_FAQ_QUESTIONS_ANSWERS =
	"REQUEST_FAQ_QUESTIONS_ANSWERS";
export const RECEIVE_FAQ_QUESTIONS_ANSWERS =
	"RECEIVE_FAQ_QUESTIONS_ANSWERS";